import { gql } from "@apollo/client";

export const GET_REQUERIMIENTOS_ADICIONALES_RI_BY_ID = gql`
query RequerimientosAdicionales (
    $idDatosGenerales: Int!
) {
    adicionalRIById (
        idDatosGeneralesRI: $idDatosGenerales
    ){
        idAdicionalRI
        idDatosGeneralesRI
        idComboRIValorReqAdicional
    }
}`;